import React, { Fragment, useContext } from 'react';
import PageLastUpdated from './PageLastUpdated';
import { PageContext } from '../../context/PageContext';
import { sanitizeHTML } from '../../utilities/sanitizeHTML';

export default (props) => {
    const { page } = useContext(PageContext);

    const title = sanitizeHTML(page?.title);

    return (
        <div className="page-middle-width" id="page-top">
            <h1
                className="page-title mb1"
                dangerouslySetInnerHTML={{
                    __html: title,
                }}
            />
            <PageLastUpdated page={page} />
        </div>
    );
};
